var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 2.88892L19.0003 4.88892M19.0003 4.88892L22.0003 7.88892L18.5003 11.3889L15.5003 8.38892M19.0003 4.88892L15.5003 8.38892M11.3903 12.4989C11.9066 13.0084 12.3171 13.615 12.598 14.2837C12.879 14.9525 13.0249 15.6702 13.0273 16.3955C13.0297 17.1209 12.8887 17.8396 12.6122 18.5102C12.3357 19.1808 11.9293 19.7901 11.4164 20.3031C10.9035 20.816 10.2942 21.2224 9.62358 21.4988C8.95296 21.7753 8.23427 21.9164 7.50891 21.9139C6.78354 21.9115 6.06582 21.7656 5.39707 21.4847C4.72831 21.2037 4.12174 20.7933 3.61227 20.2769C2.6104 19.2396 2.05604 17.8503 2.06857 16.4082C2.0811 14.9661 2.65953 13.5867 3.67927 12.5669C4.69902 11.5472 6.07849 10.9687 7.52057 10.9562C8.96265 10.9437 10.352 11.498 11.3893 12.4999L11.3903 12.4989ZM11.3903 12.4989L15.5003 8.38892",
    stroke: "#251169",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon_key.9cba9d8447badb1c3eff1126c644da76.svg";
export { ForwardRef as ReactComponent };